import React from 'react'
import PropTypes from 'prop-types'
import AlertIcon from '@argos/icons/esnext/Alert/Alert'
import SuccessIcon from '@argos/icons/esnext/Success/Success'
import ExpandIcon from '@argos/icons/esnext/Expand/Expand'
import bem from '@argos/utils/esnext/bem'

import './alert.scss'

const cn = bem({ prefix: 'ac-', block: 'alert' })

const SvgIcon = ({ iconName, iconColor }) => {
  const iconList = {
    tick: SuccessIcon,
    cross: ExpandIcon,
    error: AlertIcon,
  }
  const Icon = iconList[iconName]
  return (
    <div className={cn('svg')}>
      <Icon height='100%' width='100%' className={cn('icon', iconName, `text-color-${iconColor}`)} />
    </div>
  )
}

const Alert = ({
  size,
  children,
  borderColor,
  backgroundColor,
  textColor,
  iconColor,
  icon,
  hasBorder,
  hasSVG,
  className,
}) => {
  const backgroundColorClass = `background-color-${backgroundColor}`
  const textColorClass = `text-color-${textColor}`
  const borderColorClass = `text-color-${borderColor}`
  return (
    <div
      className={cn(null, { [`${size}`]: size, bordered: hasBorder }, [
        className,
        backgroundColorClass,
        borderColorClass,
      ])}>
      <div className={cn('content')}>
        {hasSVG && <SvgIcon iconName={icon} iconColor={iconColor || textColor} />}
        <span className={cn('message', null, textColorClass)}>{children}</span>
      </div>
    </div>
  )
}

Alert.propTypes = {
  size: PropTypes.oneOf(['', 'large']),
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  iconColor: PropTypes.string,
  textColor: PropTypes.string,
  icon: PropTypes.oneOf(['error', 'tick', 'cross']),
  hasBorder: PropTypes.bool,
  hasSVG: PropTypes.bool,
  className: PropTypes.string,
}

Alert.defaultProps = {
  size: '',
  icon: 'error',
  hasBorder: true,
  hasSVG: true,
  className: '',
}

export default Alert
